import { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { IoClose } from "react-icons/io5";

const Modal = (props) => {
    const {
        title,
        onClick,
        isOpen,
        onClose = () => { },
        children,
        w = "50%",
        h = "50%",
        overflow = "hidden",
        maxW = "100%",
        minH = "auto",
        zIndexs = 1100, // por encima de la barra fija del checkout (.dp-footer, z-index 1000)
    } = props;

    useEffect(() => {
        document.body.style.overflow = isOpen ? 'hidden' : 'auto';
        return () => { document.body.style.overflow = 'auto'; };
    }, [isOpen]);

    const handleClose = () => { onClick?.(); onClose?.(); };

    return (
        <AnimatePresence>
            {isOpen && (
                <>
                    {/* Overlay */}
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 0.22 }}
                        onClick={handleClose}
                        style={{
                            position: "fixed",
                            inset: 0,
                            backgroundColor: "rgba(0,0,0,0.45)",
                            backdropFilter: "blur(3px)",
                            WebkitBackdropFilter: "blur(3px)",
                            zIndex: zIndexs,
                        }}
                    />

                    {/* Contenedor centrado */}
                    <motion.div
                        style={{
                            position: "fixed",
                            inset: 0,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            zIndex: zIndexs + 10,
                            padding: "16px",
                            boxSizing: "border-box",
                        }}
                        initial={{ opacity: 0, scale: 0.92, y: 12 }}
                        animate={{ opacity: 1, scale: 1, y: 0 }}
                        exit={{ opacity: 0, scale: 0.92, y: 12 }}
                        transition={{ duration: 0.25, ease: [0.34, 1.1, 0.64, 1] }}
                    >
                        <div
                            onClick={(e) => e.stopPropagation()}
                            style={{
                                background: "#FFFFFF",
                                borderRadius: "24px",
                                boxShadow: "0 20px 60px rgba(0,0,0,0.18)",
                                width: w,
                                maxWidth: maxW,
                                minHeight: minH,
                                maxHeight: "88vh",
                                overflow: "hidden",
                                display: "flex",
                                flexDirection: "column",
                            }}
                        >
                            {/* Header */}
                            <div style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                padding: "18px 20px 14px 20px",
                                borderBottom: "1.5px solid #F0F0F5",
                                flexShrink: 0,
                            }}>
                                <span style={{
                                    fontSize: "17px",
                                    fontWeight: "700",
                                    color: "#1A1A2E",
                                    letterSpacing: "-0.2px",
                                }}>
                                    {title}
                                </span>
                                <button
                                    onClick={handleClose}
                                    style={{
                                        background: "#F3F2F4",
                                        border: "none",
                                        borderRadius: "99px",
                                        width: "32px",
                                        height: "32px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        cursor: "pointer",
                                        color: "#5C5C7A",
                                        flexShrink: 0,
                                    }}
                                >
                                    <IoClose size={18} />
                                </button>
                            </div>

                            {/* Contenido desplazable */}
                            <div style={{ flexGrow: 1, overflowY: "auto" }}>
                                {children}
                            </div>
                        </div>
                    </motion.div>
                </>
            )}
        </AnimatePresence>
    );
};

export default Modal;
